import { useState, useEffect, useRef, useCallback } from "react";
import BotonMapaProceso from "./BotonMapaProceso";
import { subirDatos } from "./syncSupabase";
import ariaAvatar from "./assets/aria-avatar.jpeg";
import { authHeader } from './supabase';
const hexKeyframes = `@keyframes rotateHex { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`;
// ── MARKDOWN RENDERER ─────────────────────────────────────────
function MarkdownText({ texto, color }) {
  const lines = texto.split('\n');
  return (
    <div style={{ color }}>
      {lines.map((line, i) => {
        if (line.startsWith('### ')) return <p key={i} style={{ fontWeight: '700', fontSize: '14px', margin: '8px 0 4px', color }}>{line.slice(4)}</p>;
        if (line.startsWith('## ')) return <p key={i} style={{ fontWeight: '700', fontSize: '15px', margin: '10px 0 4px', color }}>{line.slice(3)}</p>;
        if (line.startsWith('# ')) return <p key={i} style={{ fontWeight: '700', fontSize: '16px', margin: '10px 0 4px', color }}>{line.slice(2)}</p>;
        if (line.startsWith('- ') || line.startsWith('* ')) return <p key={i} style={{ margin: '2px 0', paddingLeft: '12px', color }}>• {renderInline(line.slice(2), color)}</p>;
        if (/^\d+\. /.test(line)) return <p key={i} style={{ margin: '2px 0', paddingLeft: '12px', color }}>{line}</p>;
        if (line.trim() === '') return <br key={i}/>;
        return <p key={i} style={{ margin: '2px 0', lineHeight: '1.7', color }}>{renderInline(line, color)}</p>;
      })}
    </div>
  );
}
function renderInline(text, color) {
  const parts = text.split(/(\*\*[^*]+\*\*|\*[^*]+\*|`[^`]+`)/g);
  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**')) return <strong key={i}>{part.slice(2,-2)}</strong>;
    if (part.startsWith('*') && part.endsWith('*')) return <em key={i}>{part.slice(1,-1)}</em>;
    if (part.startsWith('`') && part.endsWith('`')) return <code key={i} style={{ background: 'rgba(0,0,0,0.15)', padding: '1px 5px', borderRadius: '4px', fontFamily: 'monospace', fontSize: '12px' }}>{part.slice(1,-1)}</code>;
    return part;
  });
}
const sugerencias = [
  "¿Cómo aumento ventas en la crisis actual?",
  "Analizá oportunidades comerciales para la pyme",
  "Redactame un procedimiento ISO 9001",
  "Analizá esta no conformidad",
  "¿Qué requisitos para la insignia Oro?",
  "Ayudame a preparar la auditoría",
  "¿Cómo reduzco errores en Pre Prensa?",
  "Generame un plan de mantenimiento TPM",
  "¿Cómo uso ALQOS™ como argumento de ventas?",
  "Preparame informe para dirección",
];
const SYSTEM_PROMPT = `Sos ARIA, la asistente de inteligencia artificial integrada en ALQOS™, Sistema de Gestión Integral desarrollado por QORVEX.
IDENTIDAD Y ROL:
Sos copiloto experto en gestión integral de calidad, medio ambiente, seguridad, producción y estrategia comercial. Trabajás para la administradora del sistema, Jefa de Calidad en una empresa industrial gráfica argentina. Tu objetivo es resolver problemas, optimizar procesos, asegurar cumplimiento normativo y generar valor comercial con enfoque práctico, claro y aplicable en planta y en la dirección.
FUNCIONES PRINCIPALES:
- Resolver problemas técnicos del software ALQOS™
- Redactar procedimientos e instructivos según ISO 9001:2015, ISO 14001:2015, FSC y FSSC 22000
- Analizar no conformidades: causa raíz + acción correctiva + acción preventiva
- Preparar auditorías internas y externas
- Generar indicadores, reportes y dashboards
- Redactar comunicaciones formales
- Asistir en el Programa de Calidad Asegurada (Bronce, Plata, Oro)
- ANÁLISIS COMERCIAL: identificar oportunidades de ventas, clientes en riesgo, segmentos rentables
- ESTRATEGIA EN CRISIS: proponer acciones concretas para aumentar ventas en contexto de caída de demanda argentina
- INNOVACIÓN: generar ideas creativas y accionables para diferenciarse en el mercado gráfico
- TPM: asistir en planificación de mantenimiento, análisis de fallas y cálculo de OEE
- PRE PRENSA: detectar errores frecuentes, proponer checklists y protocolos de verificación
- ANÁLISIS DE IMÁGENES: analizar fotos de defectos de impresión, NCs visuales, documentos escaneados
- ANÁLISIS DE DATOS: interpretar tablas de Excel/CSV, identificar tendencias y anomalías
ANÁLISIS COMERCIAL Y VENTAS:
Cuando te consulten sobre ventas, caída de demanda o estrategia comercial, analizá desde múltiples ángulos:
1. RETENCIÓN: identificar clientes de mayor valor que pueden estar en riesgo
2. PENETRACIÓN: detectar oportunidades de venta cruzada en clientes existentes
3. DIFERENCIACIÓN: proponer servicios o propuestas de valor únicas para el mercado gráfico
4. EFICIENCIA: reducir costos de reproceso para mejorar margen sin subir precios
5. DIGITALIZACIÓN: usar ALQOS™ como argumento de venta ante clientes que valoran la trazabilidad
6. NUEVOS MERCADOS: identificar nichos o segmentos poco explotados en el rubro gráfico argentino
CONTEXTO DEL MERCADO GRÁFICO ARGENTINO 2026:
- Caída de demanda estimada en 30% en algunos segmentos
- Presión sobre precios por costos de insumos dolarizados
- Oportunidades en: packaging premium, e-commerce, exportación, impresión personalizada
- Diferenciadores clave: calidad certificada, trazabilidad, cumplimiento FSC para exportación
- ALQOS™ es un argumento de venta: demuestra sistema de gestión profesional ante clientes exigentes
CONTEXTO DE LA EMPRESA:
- Industria: gráfica (impresión offset plano, estuches en cartón y cartulina)
- Certificaciones: ISO 9001:2015, ISO 14001:2015, FSC cadena de custodia
- Problemas frecuentes: gramaje variable, fallas de impresión, adhesión de stickers, humedad ambiental
- Procesos clave: Pre Prensa → Impresión Offset → Post Prensa → Control de Calidad → Despacho
- ALQOS™ integra: ISO 9001, ISO 14001, FSC, FSSC 22000 y Programa de Calidad Asegurada by QORVEX
REGLAS DE DECISIÓN:
- Si consultan sobre NC: identificá causa raíz, acción correctiva y preventiva, nivel de escalamiento
- Si consultan sobre procedimiento: redactalo completo con objetivo, alcance, responsabilidades y desarrollo
- Si consultan sobre ventas o estrategia: analizá con los 6 ángulos comerciales y proponé acciones concretas
- Si consultan sobre Pre Prensa: proponé checklists, protocolos de prevención de errores
- Si consultan sobre TPM: asistí en planificación, análisis OEE, MTTR y MTBF
- Si recibís una imagen: analizála en detalle, identificá defectos, problemas de calidad o lo que sea relevante
- Si recibís un PDF o documento: extraé información clave y respondé según el contexto
- Si recibís datos de Excel/CSV: analizá la tabla completa, identificá tendencias, anomalías y oportunidades
- Siempre respondé en español, de forma clara, práctica y accionable
- Usá formato markdown: **negrita**, ## títulos, - listas cuando corresponda
NIVELES DE ESCALAMIENTO NC:
- 🟢 Bajo: lo resuelve el sector, sin intervención de calidad
- 🟡 Medio: interviene calidad, seguimiento formal requerido
- 🔴 Alto: escala a dirección, acta y evidencia obligatoria
Respondé siempre en español. Sé directa, práctica y accionable. Sos parte del equipo.`;
const URL_SB = 'https://memdufxubnwfvczzkzrj.supabase.co';
const KEY_SB = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1lbWR1Znh1Ym53ZnZjenprenJqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc2ODE5MzQsImV4cCI6MjA5MzI1NzkzNH0.nf4Fe1wYJcOOMXCqG1Zgibd-IJjcOSprLw-B_8JlmIY';
async function sbFetch(path, options = {}) {
  const res = await fetch(URL_SB + path, {
    ...options,
    headers: { 'Content-Type': 'application/json', 'apikey': KEY_SB, 'Authorization': 'Bearer ' + KEY_SB, ...(options.headers || {}) }
  });
  return res;
}
function generarId() { return Math.floor(Date.now()); }
function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result.split(',')[1]);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
async function procesarArchivo(file) {
  const tipo = file.type;
  const nombre = file.name;
  const ext = nombre.split('.').pop().toLowerCase();
  // CSV — texto plano, no necesita librería
  if (ext === 'csv' || tipo.includes('csv')) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        resolve({ tipo: 'texto', nombre, contenido: `📊 **Archivo:** ${nombre}\n\n\`\`\`\n${e.target.result.slice(0, 3000)}\n\`\`\`\n\n`, preview: null });
      };
      reader.readAsText(file);
    });
  }
  // Excel (.xlsx) — leer contenido real con exceljs
  if (ext === 'xlsx' || tipo.includes('spreadsheet')) {
    return new Promise(async (resolve) => {
      try {
        const ExcelJS = await import('exceljs');
        const arrayBuffer = await file.arrayBuffer();
        const wb = new ExcelJS.Workbook();
        await wb.xlsx.load(arrayBuffer);
        let texto = `📊 **Archivo:** ${nombre}\n\n`;
        wb.worksheets.forEach(ws => {
          let csv = '';
          ws.eachRow({ includeEmpty: false }, (row) => {
            csv += row.values.slice(1).map(v => (v ?? '')).join(',') + '\n';
          });
          texto += `**Hoja: ${ws.name}**\n\`\`\`\n${csv.slice(0, 3000)}\n\`\`\`\n\n`;
        });
        resolve({ tipo: 'texto', nombre, contenido: texto, preview: null });
      } catch(e) {
        resolve({ tipo: 'texto', nombre, contenido: `[Error al leer ${nombre}]`, preview: null });
      }
    });
  }
  // Word — extraer texto con mammoth
  if (ext === 'docx' || ext === 'doc' || tipo.includes('word')) {
    return new Promise(async (resolve) => {
      try {
        const mammoth = await import('mammoth');
        const arrayBuffer = await file.arrayBuffer();
        const result = await mammoth.extractRawText({ arrayBuffer });
        resolve({ tipo: 'texto', nombre, contenido: `📝 **Archivo Word:** ${nombre}\n\n${result.value.slice(0, 3000)}`, preview: null });
      } catch(e) {
        resolve({ tipo: 'texto', nombre, contenido: `[Error al leer ${nombre}]`, preview: null });
      }
    });
  }
  // TXT
  if (ext === 'txt' || tipo === 'text/plain') {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => resolve({ tipo: 'texto', nombre, contenido: `📋 **Archivo:** ${nombre}\n\n${e.target.result.slice(0, 3000)}`, preview: null });
      reader.readAsText(file);
    });
  }
  // Imagen
  if (tipo.startsWith('image/')) {
    const base64 = await fileToBase64(file);
    return { tipo: 'imagen', nombre, base64, mediaType: tipo, preview: `data:${tipo};base64,${base64}` };
  }
  // PDF
  if (tipo === 'application/pdf' || ext === 'pdf') {
    const base64 = await fileToBase64(file);
    return { tipo: 'pdf', nombre, base64, preview: null };
  }
  return { tipo: 'desconocido', nombre, contenido: `[Archivo adjunto: ${nombre}]`, preview: null };
}
export default function Aria({ onVolver, oscuro: oscuroGlobal, usuario }) {
  const [oscuroLocal, setOscuroLocal] = useState(oscuroGlobal);
  const oscuro = oscuroLocal;
  const [vista, setVista] = useState("chat");
  const [panelAbierto, setPanelAbierto] = useState(true);
  const fileInputRef = useRef(null);
  const chatEndRef = useRef(null);
  const textareaRef = useRef(null);
  const [conversaciones, setConversaciones] = useState([]);
  const [convActiva, setConvActiva] = useState(null);
  const [mensajes, setMensajes] = useState([]);
  const [cargandoConvs, setCargandoConvs] = useState(true);
  const [input, setInput] = useState("");
  const [cargando, setCargando] = useState(false);
  const [archivoPendiente, setArchivoPendiente] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [busqueda, setBusqueda] = useState("");
  const [generandoReporte, setGenerandoReporte] = useState(false);
  const [toast, setToast] = useState(null);
  const navBg     = oscuro ? "#060f30" : "#09184D";
  const bg        = oscuro ? "#1a1a2e" : "#F0EEFF";
  const cardBg    = oscuro ? "#0d2160" : "white";
  const panelBg   = oscuro ? "#080f2a" : "#f8f7ff";
  const borde     = oscuro ? "#1e3a8a" : "#dde3f0";
  const textoChat = oscuro ? "#c4d4f0" : "#2F3E2E";
  const subtexto  = oscuro ? "#9aabd4" : "#808085";
  const bubbleAria  = oscuro ? "rgba(123,91,242,.1)" : "#f0eeff";
  const bubbleBorde = oscuro ? "rgba(123,91,242,.2)" : "#d4c8ff";
  const [feedbacks, setFeedbacks] = useState(() => {
    try { return JSON.parse(localStorage.getItem('alqos_feedback') || '[]'); } catch { return []; }
  });
  // Auto scroll
  useEffect(() => { chatEndRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [mensajes, cargando]);
  useEffect(() => {
    cargarConversaciones();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  // Pegar imagen con Ctrl+V
  useEffect(() => {
    const handlePaste = async (e) => {
      const items = e.clipboardData?.items;
      if (!items) return;
      for (const item of items) {
        if (item.type.startsWith('image/')) {
          const file = item.getAsFile();
          if (file) {
            const procesado = await procesarArchivo(file);
            setArchivoPendiente(procesado);
          }
        }
      }
    };
    window.addEventListener('paste', handlePaste);
    return () => window.removeEventListener('paste', handlePaste);
  }, []);
  const cargarConversaciones = async () => {
    setCargandoConvs(true);
    try {
      const nombreUsuario = usuario?.nombre || 'default';
      const res = await sbFetch(`/rest/v1/aria_historial?select=data&order=id.desc&data->>usuario=eq.${encodeURIComponent(nombreUsuario)}`);
      const rows = await res.json();
      const convs = rows.map(r => r.data);
      setConversaciones(convs);
    } catch(e) { console.error(e); }
    setCargandoConvs(false);
  };
  const guardarConversacion = async (conv) => {
    const res = await sbFetch(`/rest/v1/aria_historial`, {
      method: 'POST',
      headers: { 'Prefer': 'resolution=merge-duplicates' },
      body: JSON.stringify({ id: conv.id, data: conv })
    });
    if (!res.ok) console.error('Error guardando conversación ARIA:', await res.text());
  };
  const nuevaConversacion = useCallback(() => {
    const conv = {
      id: generarId(),
      usuario: usuario?.nombre || 'default',
      titulo: 'Nueva conversación',
      fecha: new Date().toISOString(),
      mensajes: [{ rol: "aria", texto: `Hola ${usuario?.nombre || ""}! Soy ARIA. ¿En qué te ayudo hoy?` }]
    };
    setConvActiva(conv);
    setMensajes(conv.mensajes);
    setConversaciones(prev => [conv, ...prev]);
    guardarConversacion(conv);
  }, [usuario]); // eslint-disable-line react-hooks/exhaustive-deps
  const abrirConversacion = (conv) => { setConvActiva(conv); setMensajes(conv.mensajes); };
  const eliminarConversacion = async (id) => {
    await sbFetch(`/rest/v1/aria_historial?id=eq.${id}`, { method: 'DELETE' });
    setConversaciones(prev => prev.filter(c => c.id !== id));
    if (convActiva?.id === id) { setConvActiva(null); setMensajes([]); }
  };
  const exportarConversacion = () => {
    if (!convActiva) return;
    const texto = mensajes.map(m => `[${m.rol.toUpperCase()}]\n${m.texto}\n`).join('\n---\n\n');
    const blob = new Blob([texto], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `ARIA_${convActiva.titulo.slice(0,30)}_${new Date().toISOString().slice(0,10)}.txt`;
    a.click();
    URL.revokeObjectURL(url);
  };
  const handleArchivo = async (file) => {
    if (!file) return;
    const procesado = await procesarArchivo(file);
    setArchivoPendiente(procesado);
  };
  // Drag & Drop
  const handleDragOver = (e) => { e.preventDefault(); setIsDragging(true); };
  const handleDragLeave = () => setIsDragging(false);
  const handleDrop = async (e) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    if (file) await handleArchivo(file);
  };
  const enviar = async (texto) => {
    if ((!texto.trim() && !archivoPendiente) || cargando) return;
    if (!convActiva) { nuevaConversacion(); return; }
    const archivo = archivoPendiente;
    setArchivoPendiente(null);
    const nuevoMensaje = {
      rol: "usuario",
      texto: texto.trim() || (archivo ? `📎 ${archivo.nombre}` : ""),
      archivo: archivo ? { nombre: archivo.nombre, tipo: archivo.tipo, preview: archivo.preview, contenido: archivo.contenido } : null
    };
    const nuevaMsgs = [...mensajes, nuevoMensaje];
    setMensajes(nuevaMsgs);
    setInput("");
    setCargando(true);
    try {
      const apiMessages = nuevaMsgs
        .filter((m, idx) => !(m.rol === "aria" && idx === 0))
        .map(m => {
          if (m.rol === "usuario" && m.archivo) {
            const content = [];
            if (m.archivo.tipo === 'imagen') {
              content.push({ type: "image", source: { type: "base64", media_type: archivo?.mediaType || "image/jpeg", data: archivo?.base64 || "" } });
            } else if (m.archivo.tipo === 'pdf') {
              content.push({ type: "document", source: { type: "base64", media_type: "application/pdf", data: archivo?.base64 || "" } });
            } else if (m.archivo.contenido) {
              content.push({ type: "text", text: m.archivo.contenido });
            }
            const textoMensaje = m.texto && m.texto !== `📎 ${m.archivo.nombre}` ? m.texto : `Analizá este archivo: ${m.archivo.nombre}`;
            content.push({ type: "text", text: textoMensaje });
            return { role: "user", content };
          }
          return { role: m.rol === "usuario" ? "user" : "assistant", content: m.texto };
        });
      const response = await fetch("/api/aria", {
        method: "POST",
        headers: { ...(await authHeader()), "Content-Type": "application/json" },
        body: JSON.stringify({ model: "claude-sonnet-4-5", max_tokens: 2000, system: SYSTEM_PROMPT, messages: apiMessages })
      });
      const data = await response.json();
      const respuesta = data.content?.[0]?.text || "No pude procesar tu consulta.";
      const msgsFinales = [...nuevaMsgs, { rol: "aria", texto: respuesta }];
      setMensajes(msgsFinales);
      const titulo = nuevaMsgs.find(m => m.rol === "usuario")?.texto?.slice(0, 40) || "Conversación";
      const convActualizada = { ...convActiva, mensajes: msgsFinales, titulo, fecha: new Date().toISOString() };
      setConvActiva(convActualizada);
      setConversaciones(prev => prev.map(c => c.id === convActiva.id ? convActualizada : c));
      guardarConversacion(convActualizada);
    } catch(e) {
      console.error(e);
      setMensajes(prev => [...prev, { rol: "aria", texto: "Hubo un error de conexión." }]);
    }
    setCargando(false);
  };
  const generarReporteSesion = async () => {
    if (!convActiva || mensajes.length < 2) return;
    setGenerandoReporte(true);
    try {
      const historial = mensajes.map(m => `[${m.rol.toUpperCase()}]: ${m.texto}`).join('\n');
      const response = await fetch("/api/aria", {
        method: "POST",
        headers: { ...(await authHeader()), "Content-Type": "application/json" },
        body: JSON.stringify({
          model: "claude-sonnet-4-5", max_tokens: 1000,
          system: "Analizá esta conversación de soporte y devolvé un JSON con esta estructura exacta sin markdown: {\"problemas\": [\"...\"], \"resueltos\": [\"...\"], \"pendientes\": [\"...\"]}",
          messages: [{ role: "user", content: historial }]
        })
      });
      const data = await response.json();
      const texto = data.content?.[0]?.text || '{}';
      let analisis;
      try { analisis = JSON.parse(texto); } catch { analisis = { problemas: [], resueltos: [], pendientes: [] }; }
      const resumen = `🔍 Problemas: ${analisis.problemas?.join(', ') || 'ninguno'}\n✅ Resueltos: ${analisis.resueltos?.join(', ') || 'ninguno'}\n⏳ Pendientes: ${analisis.pendientes?.join(', ') || 'ninguno'}`;
      const existentes = JSON.parse(localStorage.getItem('alqos_feedback') || '[]');
      const nuevo = {
        id: Date.now().toString(),
        modulo: 'ARIA',
        mensaje: resumen,
        usuario: usuario?.nombre || 'Usuario',
        fecha: new Date().toISOString(),
        fechaResolucion: null,
        estado: 'pendiente',
        analisis
      };
      localStorage.setItem('alqos_feedback', JSON.stringify([nuevo, ...existentes]));
      subirDatos('alqos_feedback');
      setFeedbacks([nuevo, ...existentes]);
      const toast = "📋 Reporte de sesión generado";
      setToast(toast);
      setTimeout(() => setToast(null), 3000);
    } catch(e) { console.error(e); }
    setGenerandoReporte(false);
  };
  const marcarEstado = (id, nuevoEstado) => {
    const actualizados = feedbacks.map(f => f.id === id ? { ...f, estado: nuevoEstado, fechaResolucion: nuevoEstado === "resuelto" ? new Date().toISOString() : f.fechaResolucion } : f);
    localStorage.setItem('alqos_feedback', JSON.stringify(actualizados));
    subirDatos('alqos_feedback');
    setFeedbacks(actualizados);
    const mensajeToast = nuevoEstado === "resuelto" ? "✅ Reporte marcado como resuelto" : nuevoEstado === "en_analisis" ? "🔍 Estamos trabajando en ello" : "⏳ Reporte pendiente de revisión";
    setToast(mensajeToast);
    setTimeout(() => setToast(null), 3000);
  };
  const estadoFeedbackColor = { pendiente: "#f59e0b", en_analisis: "#7B5BF2", resuelto: "#22c55e" };
  const estadoFeedbackLabel = { pendiente: "⏳ Pendiente", en_analisis: "🔍 En análisis", resuelto: "✅ Resuelto" };
  const convsFiltradas = busqueda
    ? conversaciones.filter(c => c.titulo?.toLowerCase().includes(busqueda.toLowerCase()) || c.mensajes?.some(m => m.texto?.toLowerCase().includes(busqueda.toLowerCase())))
    : conversaciones;
  return (
    <div style={{ height: "100vh", background: bg, fontFamily: "sans-serif", display: "flex", flexDirection: "column" }}
      onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop}>
      <style>{hexKeyframes}</style>
      {toast && (
        <div style={{ position:"fixed", top:"20px", left:"50%", transform:"translateX(-50%)", background:"#09184D", color:"white", padding:"10px 20px", borderRadius:"12px", fontSize:"13px", fontWeight:"600", zIndex:2000, boxShadow:"0 4px 20px rgba(9,24,77,0.3)", border:"1px solid rgba(123,91,242,0.4)" }}>
          {toast}
        </div>
      )}
      {isDragging && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(123,91,242,.15)", border: "3px dashed #7B5BF2", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", pointerEvents: "none" }}>
          <div style={{ background: "white", borderRadius: "16px", padding: "2rem 3rem", textAlign: "center", boxShadow: "0 8px 32px rgba(123,91,242,.3)" }}>
            <p style={{ fontSize: "32px", margin: "0 0 8px" }}>📎</p>
            <p style={{ fontSize: "16px", fontWeight: "700", color: "#7B5BF2", margin: 0 }}>Soltá el archivo aquí</p>
          </div>
        </div>
      )}
      {/* NAVBAR */}
      <div style={{ background: navBg, padding: ".8rem 1.5rem", display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "1px solid rgba(123,91,242,.2)", flexShrink: 0 }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <button onClick={onVolver} style={{ background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.1)", color: "white", padding: "6px 14px", borderRadius: "10px", cursor: "pointer", fontSize: "13px" }}>← Menú</button>
          <button onClick={() => setPanelAbierto(p => !p)} style={{ background: "rgba(255,255,255,0.08)", border: "none", color: "white", padding: "6px 10px", borderRadius: "10px", cursor: "pointer", fontSize: "16px" }}>☰</button>
          <span style={{ color: "#b09cf5", fontSize: "14px", fontWeight: "700" }}>ARIA</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {convActiva && (
            <button onClick={exportarConversacion} style={{ background: "rgba(255,255,255,0.1)", border: "none", borderRadius: "20px", padding: "5px 12px", color: "white", cursor: "pointer", fontSize: "12px" }}>
              📤 Exportar
            </button>
          )}
          <button onClick={() => setVista(v => v === "chat" ? "feedback" : "chat")}
            style={{ background: vista === "feedback" ? "#7B5BF2" : "rgba(255,255,255,0.1)", border: "none", borderRadius: "20px", padding: "5px 12px", color: "white", cursor: "pointer", fontSize: "12px" }}>
            💬 Reportes {feedbacks.filter(f => f.estado === "pendiente").length > 0 && (
              <span style={{ background: "#e63946", color: "white", borderRadius: "50%", fontSize: "10px", padding: "1px 5px", marginLeft: "4px" }}>
                {feedbacks.filter(f => f.estado === "pendiente").length}
              </span>
            )}
          </button>
          <button onClick={() => setOscuroLocal(o => !o)} style={{ background: "rgba(255,255,255,0.1)", border: "none", borderRadius: "20px", padding: "5px 12px", color: "white", cursor: "pointer", fontSize: "12px" }}>
            {oscuro ? "☀️" : "🌙"}
          </button>
          <span style={{ color: "#9aabd4", fontSize: "11px" }}>👤 {usuario?.nombre}</span>
          {usuario?.rol === "Administrador" && <BotonMapaProceso moduloKey="aria" oscuro={oscuro} />}
        </div>
      </div>
      {/* BODY */}
      <div style={{ flex: 1, display: "flex", overflow: "hidden" }}>
        {/* PANEL IZQUIERDO */}
        {panelAbierto && (
          <div style={{ width: "260px", background: panelBg, borderRight: `1px solid ${borde}`, display: "flex", flexDirection: "column", flexShrink: 0 }}>
            <div style={{ padding: "1rem 1rem .5rem" }}>
              <button onClick={nuevaConversacion}
                style={{ width: "100%", padding: "10px", background: "linear-gradient(135deg, #7B5BF2, #09184D)", color: "white", border: "none", borderRadius: "10px", cursor: "pointer", fontSize: "13px", fontWeight: "700", marginBottom: "8px" }}>
                ✏️ Nueva conversación
              </button>
              <input value={busqueda} onChange={e => setBusqueda(e.target.value)}
                placeholder="🔍 Buscar conversaciones..."
                style={{ width: "100%", padding: "7px 10px", borderRadius: "8px", border: `1px solid ${borde}`, fontSize: "12px", background: cardBg, color: textoChat, outline: "none", boxSizing: "border-box" }}/>
            </div>
            <div style={{ flex: 1, overflowY: "auto", padding: "0 8px 1rem" }}>
              {cargandoConvs ? (
                <p style={{ fontSize: "12px", color: subtexto, textAlign: "center", padding: "1rem" }}>Cargando...</p>
              ) : convsFiltradas.length === 0 ? (
                <p style={{ fontSize: "12px", color: subtexto, textAlign: "center", padding: "1rem" }}>{busqueda ? "Sin resultados" : "Sin conversaciones aún"}</p>
              ) : convsFiltradas.map(conv => (
                <div key={conv.id} onClick={() => abrirConversacion(conv)}
                  style={{ padding: "10px 12px", borderRadius: "10px", marginBottom: "4px", cursor: "pointer", background: convActiva?.id === conv.id ? "rgba(123,91,242,.15)" : "transparent", border: convActiva?.id === conv.id ? `1px solid ${bubbleBorde}` : "1px solid transparent", display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "8px" }}
                  onMouseEnter={e => { if (convActiva?.id !== conv.id) e.currentTarget.style.background = "rgba(123,91,242,.06)"; }}
                  onMouseLeave={e => { if (convActiva?.id !== conv.id) e.currentTarget.style.background = "transparent"; }}>
                  <div style={{ flex: 1, overflow: "hidden" }}>
                    <p style={{ fontSize: "12px", fontWeight: "600", color: convActiva?.id === conv.id ? "#7B5BF2" : textoChat, margin: "0 0 2px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{conv.titulo}</p>
                    <p style={{ fontSize: "10px", color: subtexto, margin: 0 }}>{new Date(conv.fecha).toLocaleDateString('es-AR')} · {conv.mensajes.length} msgs</p>
                  </div>
                  <button onClick={e => { e.stopPropagation(); eliminarConversacion(conv.id); }}
                    style={{ background: "none", border: "none", color: subtexto, cursor: "pointer", fontSize: "14px", flexShrink: 0, opacity: 0.6 }}>×</button>
                </div>
              ))}
            </div>
          </div>
        )}
        {/* ÁREA PRINCIPAL */}
        {vista === "feedback" ? (
          <div style={{ flex: 1, overflowY: "auto", padding: "1.5rem 2rem", maxWidth: "800px", margin: "0 auto", width: "100%" }}>
            <h3 style={{ fontSize: "15px", fontWeight: "600", color: oscuro ? "white" : "#09184D", marginBottom: "1rem" }}>Panel de reportes</h3>
            {/* MÉTRICAS */}
            <div style={{ display:"flex", gap:"10px", marginBottom:"1.5rem", flexWrap:"wrap" }}>
              {[
                { label:"Total", valor: feedbacks.length, color:"#7B5BF2" },
                { label:"Pendientes", valor: feedbacks.filter(f=>f.estado==="pendiente").length, color:"#f59e0b" },
                { label:"En análisis", valor: feedbacks.filter(f=>f.estado==="en_analisis").length, color:"#7B5BF2" },
                { label:"Resueltos", valor: feedbacks.filter(f=>f.estado==="resuelto").length, color:"#22c55e" },
              ].map(m => (
                <div key={m.label} style={{ flex:1, minWidth:"80px", background: cardBg, border:`1px solid ${borde}`, borderRadius:"12px", padding:"12px", textAlign:"center" }}>
                  <p style={{ fontSize:"22px", fontWeight:"700", color:m.color, margin:"0 0 2px" }}>{m.valor}</p>
                  <p style={{ fontSize:"10px", color:subtexto, margin:0 }}>{m.label}</p>
                </div>
              ))}
            </div>
            {/* GANTT */}
            {feedbacks.length > 0 && (
              <div style={{ background:cardBg, border:`1px solid ${borde}`, borderRadius:"12px", padding:"1rem", marginBottom:"1.5rem" }}>
                <p style={{ fontSize:"12px", fontWeight:"700", color: oscuro?"white":"#09184D", margin:"0 0 12px" }}>📊 Línea de tiempo de reportes</p>
                {(() => {
                  const ahora = new Date();
                  const fechas = feedbacks.map(f => new Date(f.fecha)).filter(Boolean);
                  const minFecha = fechas.length ? new Date(Math.min(...fechas)) : ahora;
                  const totalMs = ahora - minFecha || 1;
                  return [...feedbacks].reverse().slice(0,8).map(f => {
                    const inicio = new Date(f.fecha);
                    const fin = f.fechaResolucion ? new Date(f.fechaResolucion) : ahora;
                    const left = ((inicio - minFecha) / totalMs) * 100;
                    const width = Math.max(((fin - inicio) / totalMs) * 100, 2);
                    const color = f.estado==="resuelto" ? "#22c55e" : f.estado==="en_analisis" ? "#7B5BF2" : "#f59e0b";
                    return (
                      <div key={f.id} style={{ marginBottom:"8px" }}>
                        <p style={{ fontSize:"10px", color:subtexto, margin:"0 0 3px", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>
                          {f.modulo} — {f.mensaje?.slice(0,40)}
                        </p>
                        <div style={{ position:"relative", height:"10px", background: oscuro?"rgba(255,255,255,0.05)":"#f0eeff", borderRadius:"6px", overflow:"hidden" }}>
                          <div style={{ position:"absolute", left:`${left}%`, width:`${width}%`, height:"100%", background:color, borderRadius:"6px", minWidth:"6px" }}/>
                        </div>
                      </div>
                    );
                  });
                })()}
                <div style={{ display:"flex", justifyContent:"space-between", marginTop:"6px" }}>
                  <span style={{ fontSize:"9px", color:subtexto }}>Primer reporte</span>
                  <span style={{ fontSize:"9px", color:subtexto }}>Hoy</span>
                </div>
              </div>
            )}
            {feedbacks.length === 0
              ? <div style={{ textAlign: "center", padding: "3rem", color: subtexto }}><p style={{ fontSize: "32px" }}>💬</p><p>No hay reportes aún</p></div>
              : [...feedbacks].reverse().map((f, i) => (
                  <div key={f.id} style={{ background: cardBg, borderRadius: "12px", padding: "1.2rem", border: `1px solid ${borde}`, marginBottom: "10px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                      <span style={{ fontSize: "11px", fontWeight: "700", color: "#7B5BF2", background: bubbleAria, padding: "2px 8px", borderRadius: "10px" }}>{f.modulo}</span>
                      <span style={{ fontSize: "11px", fontWeight: "700", color: estadoFeedbackColor[f.estado] }}>{estadoFeedbackLabel[f.estado]}</span>
                    </div>
                    <p style={{ fontSize: "13px", color: textoChat, margin: "0 0 10px", lineHeight: "1.5" }}>{f.mensaje}</p>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <span style={{ fontSize: "11px", color: subtexto }}>{f.usuario} · {new Date(f.fecha).toLocaleDateString('es-AR')}</span>
                      <div style={{ display: "flex", gap: "6px" }}>
                        {["pendiente", "en_analisis", "resuelto"].map(estado => (
                          <button key={estado} onClick={() => marcarEstado(f.id, estado)}
                            style={{ padding: "4px 8px", borderRadius: "8px", fontSize: "10px", cursor: "pointer", fontWeight: "600", border: f.estado === estado ? `1.5px solid ${estadoFeedbackColor[estado]}` : `1px solid ${borde}`, background: f.estado === estado ? `${estadoFeedbackColor[estado]}22` : "transparent", color: f.estado === estado ? estadoFeedbackColor[estado] : subtexto }}>
                            {estadoFeedbackLabel[estado]}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                ))
            }
          </div>
        ) : (
          <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
            {!convActiva ? (
              <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "1.5rem", padding: "2rem" }}>
                <div style={{ width:"90px", height:"90px", borderRadius:"50%", overflow:"hidden", boxShadow:"0 4px 24px rgba(123,91,242,0.3)" }}><img src={ariaAvatar} alt="ARIA" style={{ width:"100%", height:"100%", objectFit:"cover" }}/></div>
                <div style={{ textAlign: "center" }}>
                  <h2 style={{ fontSize: "22px", fontWeight: "700", color: oscuro ? "white" : "#09184D", margin: "0 0 8px" }}>ARIA — ALQOS Intelligence</h2>
                  <p style={{ fontSize: "13px", color: subtexto, margin: "0 0 4px" }}>Seleccioná una conversación o iniciá una nueva</p>
                  <p style={{ fontSize: "11px", color: subtexto, margin: 0 }}>Podés arrastrar archivos, pegar imágenes con Ctrl+V o adjuntar con 📎</p>
                </div>
                <button onClick={nuevaConversacion}
                  style={{ padding: "12px 28px", background: "linear-gradient(135deg, #7B5BF2, #09184D)", color: "white", border: "none", borderRadius: "12px", cursor: "pointer", fontSize: "14px", fontWeight: "700" }}>
                  ✏️ Nueva conversación
                </button>
                <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", justifyContent: "center", maxWidth: "600px" }}>
                  {sugerencias.slice(0,6).map(s => (
                    <button key={s} onClick={() => { nuevaConversacion(); setTimeout(() => enviar(s), 300); }}
                      style={{ background: bubbleAria, border: `1px solid ${bubbleBorde}`, color: oscuro ? "#9aabd4" : "#7B5BF2", fontSize: "11px", padding: "6px 12px", borderRadius: "20px", cursor: "pointer" }}>
                      {s}
                    </button>
                  ))}
                </div>
              </div>
            ) : (
              <>
                <div style={{ padding: ".8rem 1.5rem", borderBottom: `1px solid ${borde}`, display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <div style={{ width:"32px", height:"32px", borderRadius:"50%", overflow:"hidden", flexShrink:0 }}><img src={ariaAvatar} alt="ARIA" style={{ width:"100%", height:"100%", objectFit:"cover" }}/></div>
                    <div>
                      <p style={{ fontSize: "13px", fontWeight: "700", color: oscuro ? "white" : "#09184D", margin: 0 }}>{convActiva.titulo}</p>
                      <p style={{ fontSize: "10px", color: subtexto, margin: 0 }}>{new Date(convActiva.fecha).toLocaleDateString('es-AR')} · {mensajes.length} mensajes</p>
                    </div>
                  </div>
                  <button onClick={generarReporteSesion} disabled={generandoReporte || mensajes.length < 2}
                    title="Generar reporte de sesión"
                    style={{ background: generandoReporte ? "rgba(123,91,242,0.2)" : "rgba(123,91,242,0.1)", border:"1px solid rgba(123,91,242,0.3)", borderRadius:"10px", padding:"6px 12px", color:"#7B5BF2", cursor:"pointer", fontSize:"11px", fontWeight:"600" }}>
                    {generandoReporte ? "⏳ Analizando..." : "📋 Generar reporte"}
                  </button>
                </div>
                <div style={{ flex: 1, overflowY: "auto", padding: "1.5rem", display: "flex", flexDirection: "column", gap: "1rem" }}>
                  {mensajes.map((m, i) => (
                    <div key={i} style={{ display: "flex", gap: "10px", flexDirection: m.rol === "usuario" ? "row-reverse" : "row" }}>
                      <div style={{ width: "28px", height: "28px", borderRadius: "50%", overflow: "hidden", flexShrink: 0 }}>
                        {m.rol === "usuario"
                          ? <div style={{ width: "100%", height: "100%", background: "#7B5BF2", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "10px", fontWeight: "700", color: "white" }}>{usuario?.nombre?.[0] || "A"}</div>
                          : <img src={ariaAvatar} alt="ARIA" style={{ width: "100%", height: "100%", objectFit: "cover" }}/>
                        }
                      </div>
                      <div style={{ maxWidth: "75%" }}>
                        {m.archivo?.preview && (
                          <img src={m.archivo.preview} alt={m.archivo.nombre} style={{ maxWidth: "100%", maxHeight: "200px", borderRadius: "10px", marginBottom: "6px", display: "block" }}/>
                        )}
                        {m.archivo && !m.archivo.preview && (
                          <div style={{ padding: "8px 12px", background: m.rol === "usuario" ? "rgba(255,255,255,0.15)" : bubbleAria, borderRadius: "8px", marginBottom: "6px", fontSize: "12px", color: m.rol === "usuario" ? "white" : textoChat, border: `1px solid ${bubbleBorde}` }}>
                            📄 {m.archivo.nombre}
                          </div>
                        )}
                        {m.texto && m.texto !== `📎 ${m.archivo?.nombre}` && (
                          <div style={{ padding: ".75rem 1rem", borderRadius: "16px", fontSize: "13px", background: m.rol === "usuario" ? "#7B5BF2" : bubbleAria, border: m.rol === "usuario" ? "none" : `1px solid ${bubbleBorde}`, borderTopLeftRadius: m.rol === "aria" ? "4px" : "16px", borderTopRightRadius: m.rol === "usuario" ? "4px" : "16px" }}>
                            {m.rol === "aria"
                              ? <MarkdownText texto={m.texto} color={textoChat}/>
                              : <span style={{ color: "white", lineHeight: "1.7", whiteSpace: "pre-wrap" }}>{m.texto}</span>
                            }
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                  {cargando && (
                    <div style={{ display: "flex", gap: "10px" }}>
                      <div style={{ width: "28px", height: "28px", borderRadius: "50%", overflow: "hidden", flexShrink: 0 }}>
                      <img src={ariaAvatar} alt="ARIA" style={{ width: "100%", height: "100%", objectFit: "cover" }}/>
                    </div>
                      <div style={{ padding: ".75rem 1rem", borderRadius: "16px", borderTopLeftRadius: "4px", background: bubbleAria, border: `1px solid ${bubbleBorde}`, display: "flex", gap: "5px", alignItems: "center" }}>
                        {[0,1,2].map(i => <div key={i} style={{ width: "6px", height: "6px", borderRadius: "50%", background: "#7B5BF2", animation: "rotateHex 1s ease-in-out infinite", animationDelay: `${i*0.2}s` }}/>)}
                      </div>
                    </div>
                  )}
                  <div ref={chatEndRef}/>
                </div>
                {archivoPendiente && (
                  <div style={{ padding: "8px 1.5rem", borderTop: `1px solid ${borde}`, display: "flex", alignItems: "center", gap: "10px", background: oscuro ? "rgba(123,91,242,.05)" : "#f8f7ff" }}>
                    {archivoPendiente.preview ? (
                      <img src={archivoPendiente.preview} alt="" style={{ height: "50px", borderRadius: "8px" }}/>
                    ) : (
                      <span style={{ fontSize: "12px", color: textoChat, background: bubbleAria, padding: "6px 12px", borderRadius: "8px", border: `1px solid ${bubbleBorde}` }}>
                        {archivoPendiente.tipo === 'texto' ? '📊' : '📄'} {archivoPendiente.nombre}
                      </span>
                    )}
                    <button onClick={() => setArchivoPendiente(null)} style={{ background: "none", border: "none", color: "#e63946", cursor: "pointer", fontSize: "16px" }}>×</button>
                  </div>
                )}
                <div style={{ padding: ".5rem 1.5rem", display: "flex", gap: "6px", flexWrap: "wrap", borderTop: `1px solid ${borde}` }}>
                  {sugerencias.map(s => (
                    <button key={s} onClick={() => enviar(s)}
                      style={{ background: bubbleAria, border: `1px solid ${bubbleBorde}`, color: oscuro ? "#9aabd4" : "#7B5BF2", fontSize: "11px", padding: "4px 10px", borderRadius: "20px", cursor: "pointer" }}>
                      {s}
                    </button>
                  ))}
                </div>
                <div style={{ padding: "1rem 1.5rem", display: "flex", gap: "10px" }}>
                  <input ref={fileInputRef} type="file"
                    accept="image/*,.pdf,.xlsx,.csv,.docx,.doc,.txt"
                    onChange={e => { if (e.target.files[0]) handleArchivo(e.target.files[0]); e.target.value = ''; }}
                    style={{ display: "none" }}/>
                  <button onClick={() => fileInputRef.current?.click()}
                    title="Adjuntar archivo (imagen, PDF, Excel, Word, CSV, TXT)"
                    style={{ width: "44px", height: "44px", background: archivoPendiente ? "#7B5BF2" : (oscuro ? "rgba(255,255,255,.04)" : "white"), border: `1.5px solid ${oscuro ? "rgba(123,91,242,.25)" : "#d4c8ff"}`, borderRadius: "10px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "18px", flexShrink: 0 }}>
                    📎
                  </button>
                  <div style={{ flex: 1, background: oscuro ? "rgba(255,255,255,.04)" : "white", border: `1.5px solid ${oscuro ? "rgba(123,91,242,.25)" : "#d4c8ff"}`, borderRadius: "14px", display: "flex", alignItems: "center", padding: ".75rem 1rem" }}>
                    <textarea ref={textareaRef} value={input} onChange={e => setInput(e.target.value)}
                      onKeyDown={e => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); enviar(input); } }}
                      placeholder={archivoPendiente ? "Comentá sobre el archivo... (opcional)" : "Escribile a ARIA... · Arrastrá archivos · Ctrl+V para pegar imagen"}
                      rows={1}
                      style={{ flex: 1, background: "none", border: "none", outline: "none", color: textoChat, fontFamily: "sans-serif", fontSize: "13px", resize: "none", lineHeight: "1.5" }}
                    />
                  </div>
                  <button onClick={() => enviar(input)} disabled={cargando || (!input.trim() && !archivoPendiente)}
                    style={{ width: "44px", height: "44px", background: (input.trim() || archivoPendiente) ? "#7B5BF2" : "rgba(123,91,242,.3)", border: "none", borderRadius: "10px", cursor: (input.trim() || archivoPendiente) ? "pointer" : "default", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>
                    </svg>
                  </button>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
